export default __webpack_public_path__ + "54002fec003df6bc4045e28c07866d07.svg";